// Whether the `businessDetails.*` slice of formData carries any actual value - an empty
// Business Details section (every field untouched) must not itself force a save. Shared by
// useManageDealDrawer's handleSaveMandateApplicants (save-fires-when-either gate) and the
// save-payload assembly (whether to include `businessDetails` at all).
export const hasBusinessDetailsData = (businessDetails: Record<string, any>): boolean =>
    Object.values(businessDetails || {}).some((value) => value !== '' && value !== null && value !== undefined);
